















import { computed, defineComponent } from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { defineComponentTranslations } from '~/utils/i18n'
import CStepper from '~/components/shared/configurable/stepper/CStepper.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { AuditRequest, AuditRequestStatusStatus } from '~/models/audit/request'
import AuditRowActionButtons from '~/components/shared/classified/audits/AuditRowActionButtons.vue'
import { UPDATE_AUDIT_REQUEST } from '~/store/modules/shared/classifieds/view/mutation-types'

export default defineComponent({
  components: {
    AuditRowActionButtons,
    CStepper,
    CCard
  },
  setup() {
    const { state, getters, commit } = useNamespacedStore(CLASSIFIED_VIEW_NS)
    const auditRequests = computed(() => state.auditRequests)
    const isClassifiedOwner = computed(() => getters('isOwn'))

    const pendingAcceptanceRequests = computed(() => {
      return (
        auditRequests.value
          ?.filter(
            ar =>
              ar?.currentStatus?.status ===
                AuditRequestStatusStatus.PENDING_ACCEPTANCE &&
              isClassifiedOwner.value
          )
          .reverse() || [] // reversing here to get them in created order
      )
    })

    const updateRequest = (updatedRequest: AuditRequest) => {
      commit(UPDATE_AUDIT_REQUEST, updatedRequest)
    }

    return {
      auditRequests,
      pendingAcceptanceRequests,
      isClassifiedOwner,
      updateRequest
    }
  },
  i18n: defineComponentTranslations({
    pending_audit_alert_title: {
      en: 'You have a technical inspection request',
      el: 'Έχεις αίτημα για τεχνικό έλεγχο'
    },
    pending_audit_alert_description: {
      en:
        'A person directly interested wants to purchase a technical inspection for your vehicle.',
      el:
        'Ένας άμεσα ενδιαφερόμενος θέλει να αγοράσει τεχνικό έλεγχο για το όχημά σου.'
    }
  })
})
